import React from 'react'

const Minus60 = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Chambers</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Minus 60 Deep Freezer</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/minus60.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>Minus 60 Deep Freezer:</h2>
                        <h4 style={{ textDecoration: "underline" }}>WLS-60</h4>
                        <p className="mbot25">
                            Deep Freezers are designed for storage of biological samples in biotech, life science, clinical research as well as medical & pharmaceutical specimens, serums, vaccines, blood components. These freezers are available with temperatures up to -20°C and – 40°C.
                        </p>
                        <p className='mbot25'>
                            <h4 style={{ textDecoration: "underline" }}>Features & Benefits:</h4>
                            <ul>
                                <li>Temperature Up To -20°C / -40°C (AC Room).</li>
                                <li>Upright Models With Small Foot Prints.</li>
                                <li>Unique Design Of Thermal Barrier For Better Energy Efficiency.</li>
                                <li>Machine Filled CFC Free PUF Insulation To Eliminate Void Pockets.</li>
                                <li>Adjustable Trays.</li>
                                <li>Hermetically Sealed Compressor With CFC Free Refrigerant.</li>
                                <li>Alarms For High/Low Set Parameters.</li>
                                <li>Sensor Failure Alarm.</li>
                                <li>Electrical Circuit Breaker.</li>
                                <li>Time Delay For Compressor Switch On.</li>
                                <li>Overload Cut Off Relay For Compressor.</li>
                                <li>Rounded Inner Chamber For Easy Cleaning</li>
                                <li>Attractive Door Profile</li>
                                <li>Microprocessor Controller With LED Display Of Temperature With Set, Process Value & Audio Visual Alarm (Standard).</li>
                                <li>Weight Carrying Capacity Of Each Tray : 30 Kg Uniformly Distributed.</li>
                                <li>Auto Door Closer</li>
                                <li>Smart Handle With LED Door Closure Indication</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Minus60
